import React from "react";
import wImage from "../assets/freepik__background__32116 1.png";
// import { Plus, Smartphone } from "lucide-react";

const whoWeAre = () => {
  return (
    <section className="bg-gray-50 h-auto">
      <div className="flex flex-col md:flex-row mx-auto pl-2 pr-3 md:pl-0 gap-12 md:pr-0 pt-[97px] pb-10">
        <div className="flex flex-col max-w-[600px] mx-auto gap-6">
          <h1 className="font-sans font-bold break-words text-black text-[40px] sm:text-5xl leading-[60px]">
            Who We Are
          </h1>
          <p className="font-sans font-normal text-xl text-justify leading-6">
            At SurveysIQ, we believe your opinions are powerful - and they
            deserve to be rewarded. Our platform connects everyday users with
            top companies looking for honest feedback through quick and simple
            surveys. Whether you’re looking to earn a little extra cash or
            maximize your downtime, SurveysIQ makes it easy, fun, and secure to
            get paid for your voice.
          </p>
          <p className="font-sans font-normal text-xl text-justify leading-6">
            Join our growing community and start turning your insights into
            income today!
          </p>
          {/* <div className="flex flex-row gap-5 ">
            <div
              className="flex flex-col max-w-[230px] gap-3 p-4 bg-white rounded-lg shadow-md 
                  hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group cursor-pointer"
            >
              <Plus
                className="text-green-600 w-8 h-8 bg-green-200 rounded p-1 
                     group-hover:bg-green-600 group-hover:text-white transition-all duration-300"
              />
              <h1 className="font-sans font-semibold text-[20px] leading-7 group-hover:text-green-600 transition-colors duration-300">
                Earn Money
              </h1>
              <p className="font-sans text-lg text-gray-600 group-hover:text-gray-800 transition-colors duration-300">
                Complete short surveys and get paid directly to bank account.
              </p>
            </div> */}

          {/* Mobile First */}
          {/* <div
              className="flex flex-col max-w-[230px] gap-3 p-4 bg-white rounded-lg shadow-md 
                  hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group cursor-pointer"
            >
              <Smartphone
                className="text-green-600 w-8 h-8 bg-green-200 rounded p-1 
                          group-hover:bg-green-600 group-hover:text-white transition-all duration-300"
              />
              <h1 className="font-sans font-semibold text-[20px] leading-7 group-hover:text-green-600 transition-colors duration-300">
                Mobile First
              </h1>
              <p className="font-sans text-lg text-gray-600 group-hover:text-gray-800 transition-colors duration-300">
                Optimized for mobile devices to reach respondents anywhere.
              </p>
            </div>
          </div> */}
        </div>
        <div className=" max-w-[634px]">
          <img src={wImage} alt="" />
        </div>
      </div>
    </section>
  );
};
export default whoWeAre;
